<template>
	<app-page>
		<app-heading :title="externalId ? `${externalId} (${booking.unit_code})` : booking.unit_code" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="booking.history"
					:headers="headers"
					:sort-by="'processed'"
					:sort-desc="true"
					:dynamic="false"
				>
					<template v-slot:warning="{ item }">
						<span
							v-if="item.warning"
						>{{ item.warning }}</span>
						<span v-else>N/A</span>
					</template>
					<template v-slot:error="{ item }">
							<span
								v-if="item.error"
							>
								<app-tooltip :text="item.error">
									{{ item.error.substr(0, 50) }}
									<span v-if="item.error.length > 50">...</span>
								</app-tooltip>
							</span>
							<span v-else>N/A</span>
					</template>
					<template v-slot:request="{ item }">
						<td><app-json :data="item.request" /></td>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	async created() {
		try {
			this.booking = await this.$ravello.request()
				.v(2)
				.to('bookings')
				.to(this.id)
				.get()
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
	},
	data() {
		return {
			booking: {
				content: {
					id: null,
				},
				history: [],
			},
			headers: [{
				text: 'Action',
				value: 'action',
				sortable: true,
			}, {
				text: 'Processed',
				value: 'processed',
				sortable: true,
				format: 'datetime',
			}, {
				text: 'Warning',
				value: 'warning',
				sortable: false,
			}, {
				text: 'Error',
				value: 'error',
				sortable: false,
			}, {
				text: 'Request',
				value: 'request',
				sortable: false,
			}],
		}
	},
	computed: {
		id() {
			return this.$route.params.booking
		},
		externalId() {
			return this.booking.content && this.booking.content.id
		},
	},
}
</script>
